import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetNodeRequest extends IBaseRequest {
    treeHandle?: string;
    systemId?: string;
    aclh?: string;
}

export class GetNodeRequest extends BaseRequest implements IGetNodeRequest {
    public treeHandle?: string;
    public systemId?: string;
    public aclh?: string;
  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.treeHandle = otherOptions.treeHandle;
    this.systemId = otherOptions.systemId;
    this.aclh = otherOptions.aclh;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNode(this.treeHandle, 'treeHandle');
    parameters += this.makeNode(this.systemId, 'systemId');
    parameters += this.makeNode(this.aclh, 'aclh');
    return super.wrapperXml('GetNode', parameters);
  }
}
